import React, { Component } from 'react'

export default class ConfirmationField extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const {item, remarks} = this.props
    return (
      <dl>
        <dt>{ item.input_name }</dt>
        <dd>
          {
            <React.Fragment key={`form_confirmation_${item.input_name}`}>
              <input type="checkbox" id={`form_confirmation_${item.input_name}`}/>
              <label htmlFor={`form_confirmation_${item.input_name}`}>利用規約に同意します</label>
              <br/>
              <span>続行するには、<a href={item.input_value} className='term-link' target="_blank" rel="noopener noreferrer" >利用規約</a>をお読みのうえ同意いただく必要があります。</span>
            </React.Fragment>
          }
          <p className="cap">{remarks}</p>
        </dd>
      </dl>
    )
  }
}
